<div>
  <div #carousel id="carouselExampleCaptions" class="carousel slide" data-ride="carousel" data-interval="5000">
    <ol *ngIf="aWidgetParams.content.elements.length > 1" class="carousel-indicators">
      <li *ngFor="let aItems of aWidgetParams.content.elements; first as bFirst; index as iIndex"
        data-target="#carouselExampleCaptions" attr.data-slide-to="{{ iIndex }}" [class.active]="bFirst"></li>
    </ol>

    <div class="carousel-inner">
      <div *ngFor="let aItems of aWidgetParams.content.elements; first as bFirst" class="carousel-item"
        [class.active]="bFirst">
        <img [src]="aItems.img_crop" class="w-100 d-md-none" [alt]="aItems.alt" />
        <img [src]="aItems.img" class="w-100 d-none d-md-block" [alt]="aItems.alt" />

        <div class="carousel-caption d-none d-md-block">
          <h5 *ngIf="aItems.img_caption">{{ aItems.img_caption }}</h5>
          <p *ngIf="aItems.img_comment">{{ aItems.img_comment }}</p>
        </div>
      </div>
    </div>

    <a *ngIf="aWidgetParams.content.elements.length > 1" class="carousel-control-prev" href="#carouselExampleCaptions"
      role="button" data-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="sr-only">{{ aCarouselLangData.previous }}</span>
    </a>

    <a *ngIf="aWidgetParams.content.elements.length > 1" class="carousel-control-next" href="#carouselExampleCaptions"
      role="button" data-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="sr-only">{{ aCarouselLangData.next }}</span>
    </a>
  </div>
</div>
